/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type BathEquipmentEnum = 1 | 2 | 3 | 4;

export const BathEquipmentEnum = {
    NUMBER_1: 1 as BathEquipmentEnum,
    NUMBER_2: 2 as BathEquipmentEnum,
    NUMBER_3: 3 as BathEquipmentEnum,
    NUMBER_4: 4 as BathEquipmentEnum
};

